const BannerRoutes = {
  createBanner: "/banner/create",
  getBanners: "/banner/getAll",
  deleteBanner: "/banner/delete",
}

export default BannerRoutes;